import React, { useState, useEffect, useRef } from 'react';
import Table from '../Common/table';
import axios from '../httpServices/httpService';
import api from '../config.json'
import swal from 'sweetalert';
import auth from '../httpServices/authService';
import validation from '../utill/validation';
import _, { cloneDeep, result } from 'lodash';
import joi from 'joi'
import Loading from '../utill/LoadingComponent';
import date from '../utill/dateTime';
// import EquipmentSelection from '../Common/equipmentSelection';
import { ToastContainer, toast } from 'react-toastify';
import DateSelection from '../Common/DateSelection';
import { Result, Select } from 'antd';
// import 'antd/dist/antd.css';
import { useLocation, useHistory } from 'react-router-dom';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { faMinusCircle, faPlusCircle, faThumbsDown, faThumbsUp, faCamera } from '@fortawesome/free-solid-svg-icons';
import HighSpeedDataType from '../Common/HighSpeedDataType';
const MainReport = ({ handleDownloadTableToExcel, equips, equipGroups, fromDateLimit, Heading }) => {
  const history = useHistory();
  const location = useLocation();

  const [qualityData, setQualityData] = useState([])
  const [selectedInspection,setSeletedInspection]=useState({})
  const [inputData, setInputData] = useState({ Instrument: [], CustomFields: [] })
  const [loader, setLoader] = useState(false)
  const [methods, setMethods] = useState([])
  const [FinalResult, setFinalResult] = useState([])
  const [NumberOfSample, setNumberOfSample] = useState(0)
  const [NumberOfSet, setNumberOfSet] = useState(0)

  
  const [imageURL, setImageURL] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [ModalImage, setModalImage] = useState('');
  const [List, setList] = useState([]);
  const [files, setFiles] = useState([]);
  const [templateList, setTemplateList] = useState([])
  const [columns, setSelectedColumns] = useState([])
  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] })
  const [errors, setErrors] = useState({});
  const [Enable, setEnable] = useState(true)
  const [constantFields, setConstantFields] = useState([])

  const [itemList, setItemList] = useState([]);
  const [inspectionMasterList, setInspectionMasterList] = useState([])

  const [instruments, setInstruments] = useState([]);
  const [types, setTypes] = useState([]);

  const [ChecksheetType, setCheckSheetType] = useState("")
  const [config, setConfig] = useState({})

  const [item, setItem] = useState({})
  const [obj, setObj] = useState({})
  const [focusedInput, setFocusedInput] = useState('')



  const [sampleStartIndex, setSampleStartIndex] = useState(0)

  const inputRefs = useRef([]);

  const handleFocusNext = (key) => {
    // Focus on the next input field
    console.log('Entering focus', key, inputRefs);
    if (inputRefs.current[key]) {
      inputRefs.current[key].focus();
    }
  };

console.log(FinalResult,"dfihbn")

  const initializedInputFocus = () => {
    // Ensure the focus happens after the component has mounted
    const timer = setInterval(() => {
      if (inputRefs.current["0-0-high_speed_string"]) {
        inputRefs.current["0-0-high_speed_string"].focus();
        clearInterval(timer);
      }
      else if (inputRefs.current["0Parent"] && config.SampleSerial == "Manual") {
        inputRefs.current["0Parent"].focus();
        clearInterval(timer);
      } else {
        if (inputRefs.current["00"]) {
          inputRefs.current["00"].focus();
          clearInterval(timer);
        }
      }
    }, 1);

    // return () => clearInterval(timer); // Cleanup the timer on component unmount
  }

  useEffect(() => {
    if (location.state) {
      setObj(location.state.obj)
      setItem(location.state.item)
      setCheckSheetType(location.state.ChecksheetType)
      setConfig(location.state.config)
    }
  }, [location.state])

  useEffect(() => {
    if (templateList.length > 0 && itemList.length > 0 && inspectionMasterList.length > 0) {
      getAllTypes()
      getAllInstrument()
      initializedData()
    }
  }, [obj, templateList, itemList, inspectionMasterList])

  useEffect(() => {
    getListNames()
    getAllcheckPointConfig();
    getAllInspections();
    getAllItems()
  }, [])

  useEffect(() => {
    initializedInputFocus()
  }, [config])
  useEffect(() => {
    Heading(ChecksheetType + ' Report')
  }, [ChecksheetType])


  const getAllcheckPointConfig = () => {
    axios.get(api.api + "checkPointConfig")
      .then((result) => {
        setTemplateList(result.data)
      })
      .catch((err) => {
        swal(`${err}`);
      })
  }

  const getAllItems = () => {
    axios.get(api.api + "item")
      .then((result) => {
        setItemList(result.data)
      })
      .catch((err) => {
        swal(`${err}`);
      })
  }

  const getAllInspections = () => {
    axios.get(api.api + "customInspection")
      .then((result) => {
        setInspectionMasterList(result.data)
      })
      .catch((err) => {
        swal(`${err}`);
      })
  }



  const getAllTypes = () => {
    axios.get(api.api + 'instrumentType')
      .then((result) => {
        setTypes(result.data.map((x) => { return { label: x.InstrumentType, value: x.InstrumentType, _id: x._id } }))
      })
      .catch((err) => {
        swal(`${err}`)
      })
  }

  const getAllInstrument = () => {
    axios.get(api.api + 'instrument')
      .then((result) => {
        setInstruments(result.data.map((x) => { return { type: x.InstrumentType, label: x.Instrument, value: x.Instrument, _id: x._id } }))
      })
      .catch((err) => {
        swal(`${err}`)
      })
  }

  const getNextSample = (input) => {
    // Separate the string and number
    const match = input.match(/([a-zA-Z]+)(\d+)/);

    if (match) {
      const stringPart = match[1]; // "Sample"
      const numberPart = parseInt(match[2], 10); // 1

      // Increment the number
      const incrementedNumber = numberPart + 1;

      // Combine the string part with the incremented number
      return incrementedNumber; // "Sample2"
    } else {
      return 0; // Return the original input if no match is found
    }
  }

  const getNewCheckSheetObj = (setName) => {
    const cloneItem = cloneDeep(itemList.find(x => x._id == item._id))
    const checkSheet = cloneItem && cloneItem.Inspection.find(x => x.InspectionName == ChecksheetType)
    if (checkSheet && checkSheet.checkSheetTitle) {
      const default1 = config.ResultConfigure.find(x => x.Result == config.DefaultSelection)
      checkSheet.checkSheetTitle.checkpoints.forEach((x) => {
        x.Result = default1.TreatAs;
      })
      return { setName: setName, Standard: checkSheet.checkSheetTitle.checkpoints };
    }
    return { Standard: [] }
  }

  const initializedData = async () => {

    const cloneItem = cloneDeep(itemList.find(x => x._id == item._id))
    setItem(cloneItem)
    const checkSheet = cloneItem && cloneItem.Inspection.find(x => x.InspectionName == ChecksheetType)
    if (!checkSheet || (checkSheet && !checkSheet.checkSheetTitle)) {
      if (ChecksheetType) {
        swal(`Do not have checkpoints for ${ChecksheetType} `, { dangerMode: true })
        history.goBack();
      } else {
        history.push("/DataEntry/not_found");
      }

    } else {
      if (checkSheet.checkSheetTitle && checkSheet.checkSheetTitle.checkpoints) {
        setConstantFields(checkSheet.ConstantFields)
        const template = templateList.find(x => x.Name == checkSheet.checkSheetTitle.TemplateName);
        if (template) {
          setSelectedTemplate(template)
          setSelectedColumns(template.Columns.filter(col => col.EnableForDataEntry) || [])
          //setSelectedColumns(template.Columns.map(col => col) || [])

        }
        let config1 = inspectionMasterList.find(x => x._id == config._id)
        setConfig(config1)
        const default1 = config.ResultConfigure.find(x => x.Result == config.DefaultSelection)
        const finalResult = [...FinalResult];
        // if (config.ContinousDataEntry == "disable") {
        //   setFinalResult(finalResult);

        // } else {
        //   const result = [{ Sample: "", Value: default1.TreatAs }]
        //   setFinalResult(result);
        // }

        const result = [{ Sample: "", Value: default1.TreatAs }]
        if(checkSheet.EnableSet){
        setFinalResult(Array(checkSheet.NumOfSamples*checkSheet.NumberOfSet).fill({ Sample: "", Value: default1.TreatAs }));
        
        }else{

          setFinalResult(result);
        }

        checkSheet.checkSheetTitle.checkpoints.forEach((x) => {
          if (x.StandardType == "Dimension") {
            x.Result = "NG";
            x.ResultLabel = "NG";
          } else {
            x.Result = default1.TreatAs;
            x.ResultLabel = default1.Result;
          }
        })
        const inputObj = { ...inputData };
        inputObj.CustomFields = []
        if (config1.SampleSerial == "Auto" && config1.SampleSerialUnique == "Yes") {
          const res = await axios.put(api.api + "LastSampleSerial", { InspectionType: ChecksheetType, ItemName: cloneItem.ItemName });
          const carryRes = await axios.put(api.api + "LastSampleSerial", { InspectionType: ChecksheetType, ItemName: cloneItem.ItemName, RequestType: "CarryForward" });
          const nextSample = getNextSample(res.data.Sample)
          config1.CustomFields.filter(x => !x.Constant).forEach((one) => {
            const findValue = carryRes.data.customFields.find(x => x.FieldName == one.FieldName)
            if (findValue) {
              inputObj.CustomFields.push({ FieldName: one.FieldName, Value: findValue.Value })
            } else {
              inputObj.CustomFields.push({ FieldName: one.FieldName, Value: "" })
            }
          })
          setSampleStartIndex(nextSample - 1)
        }
        setInputData(inputObj);
        setSeletedInspection(checkSheet)
       
        const SetSample = checkSheet.SetNames.map(name => ({
          SetName: name.setName,
          Standard: Array(checkSheet.NumOfSamples).fill().map(() => (
            checkSheet.checkSheetTitle.checkpoints.map(checkpoint => ({
              SetName: name.setName, // Include SetName inside each Standard object
              Standard:  checkSheet.checkSheetTitle.checkpoints.map(checkpoint => ({
                ...checkpoint, // Spread the existing checkpoint properties
                SetName: name.setName // Include SetName in each checkpoint object
              }))
              
            }))
          )).flat() // Flatten the array so all standards are in one list
        }));
       
        

        let arr=[]
        SetSample.forEach(x => {
          arr = [...arr, ...x.Standard];
        });
        
        // Sort based on SetName as a string
        arr = arr.sort((a, b) => a.SetName.localeCompare(b.SetName));
        
         setEnable(checkSheet.EnableSet)
        console.log("bd9fubjdfu", checkSheet)
        setQualityData(arr);
        // setFinalResult([{ Standard: checkSheet.checkSheetTitle.checkpoints }])
      }
      setNumberOfSample(checkSheet.NumOfSamples)
      setNumberOfSet(checkSheet.NumberOfSet||0)

    }
  }






  const handleImageChange = ({ file }, index, parentIdx) => {
    let file1 = [...files]
    if (!file1[parentIdx]) {
      file1[parentIdx] = [];
    }
    file1[parentIdx][index] = file;
    setFiles(file1)
    // setImageURL(doArray);
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      message.error('You can only upload image files!');
      return;
    }

    const isLt13M = file.size / 1024 / 1024 < 13;
    if (!isLt13M) {
      message.error('Image must be smaller than 13MB!');
      return;
    }

    const reader = new FileReader();
    const doArray = [...imageURL];

    reader.onload = e => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const max_width = 800; // max width to resize
        const max_height = 800; // max height to resize
        let width = img.width;
        let height = img.height;

        // Maintain aspect ratio
        if (width > height) {
          if (width > max_width) {
            height = Math.round((height *= max_width / width));
            width = max_width;
          }
        } else {
          if (height > max_height) {
            width = Math.round((width *= max_height / height));
            height = max_height;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Compress the image and get the data URL
        const dataUrl = canvas.toDataURL('image/jpeg', 0.8); // 0.8 is the quality from 0 to 1
        if (!doArray[parentIdx]) {
          doArray[parentIdx] = [];
        }

        // Assign the value to the specified index
        doArray[parentIdx][index] = { visible: true, image: dataUrl };

        setImageURL(doArray);
      };
    };

    reader.readAsDataURL(file);
  };

  console.log(imageURL, "icbkjasdcn")

  const handleModalOpen = (index, parentIdx) => {
    setModalImage(imageURL[parentIdx][index].image)
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };
  // const filteredOptions = clients.filter((o) => !selectedItems.find(b => o.label == b));



  // useEffect(() => {
  //   axios.get(api.api + `ConfigReport
  //   `
  //     // /${ChecksheetType}
  //   )
  //     .then((result) => {
  //       const data = result.data.filter((item) => item.ReportType === ChecksheetType)
  //       console.log(result.data, "cececec", data, ChecksheetType)
  //       setList(data.length > 0 ? data[0].CustomFields : []);
  //     })
  //     .catch((err) => {
  //       swal(`${err}`)

  //     })
  // }, [])

 




  // const handleGetData = async () => {
  //     // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
  //     setLoader(true)
  //     axios.put(api.api + 'partMaster', inputData)
  //         .then((result) => {
  //             setLoader(false)
  //             setQualityData(result.data);
  //             console.log(result.data, "-----------------");
  //         })
  //         .catch((err) => {
  //             setLoader(false)
  //             console.log(err);
  //         })
  // }


  const handleOnChange = (name, value, index) => {

    setInputData(prev => {
      const newData = { ...prev };

      // Ensure CustomFields is initialized as an array
      if (!newData.CustomFields) {
        newData.CustomFields = [];
      }

      // Ensure the specific index is initialized as an object
      if (!newData.CustomFields[index]) {
        newData.CustomFields[index] = {};
      }

      newData.CustomFields[index]['FieldName'] = name;
      newData.CustomFields[index]['Value'] = value;
      if (errors[name]) {
        const err = { ...errors }
        delete err[name]
        setErrors(err)
      }


      return newData;
    });
  };


  const validateCustomFields = (data) => {
    const error = {};
    const errMsg = "Required fields cannot be left blank: ";
    config.CustomFields.forEach(field => {

      if (field && field?.Compulsory) {
        if (data.customFields) {
          const configField = data.customFields.find(x => x && x.FieldName === field.FieldName);
          if (configField) {
            const isListType = field.DataType === "list";
            const isEmptyList = isListType && (!configField.Value || configField.Value.length === 0);
            const isEmptyValue = !isListType && !configField.Value;
            if (isEmptyList) {
              error[configField.FieldName] = errMsg;
            } else if (isEmptyValue) {
              error[configField.FieldName] = errMsg;
            }
          } else {
            if (field.DataType == 'list') {
              error[field.FieldName] = errMsg;
            } else {
              error[field.FieldName] = errMsg;
            }
          }
        } else {
          if (field.DataType == 'list') {
            error[field.FieldName] = errMsg;
          } else {
            error[field.FieldName] = errMsg;
          }
        }

      }
    });

    return Object.keys(error).length ? error : null;
  };

  const validateCheckSheetComplete = (obj) => {
    const userInputFields = columns.filter(x => x.DataType == "UserInputDecision");
    let isError = false;
    if (obj.sampleRef.length == 0) isError = true;
    for (let i = 0; i < obj.sampleRef.length; i++) {
      for (let check of obj.Checksheet) {
        for (let field of userInputFields) {
          if (check.StandardType == "Dimension" && check.Data[i] && !check.Data[i][field.DbFieldName]) {
            isError = true;
            break; // Exit inner loop if error is found
          }
        }
        if (isError) break; // Exit middle loop if error is found
      }
      if (isError) break; // Exit outer loop if error is found
    }

    return isError;
  };

  const handleProcess = (formData1) => {
    const showRemarkPrompt = () => {
      swal({
        title: "Are you sure?",
        text: "Number of samples inspected is less than the recommended number as specified in Standard. Please mention the reason for the non-compliance.",
        icon: "warning",
        content: {
          element: "input",
          attributes: {
            placeholder: "Enter your remarks here...",
            type: "text",
            id: "remarks-input", // Adding an id to target the input later
          },
        },
        buttons: {
          cancel: "Cancel",
          confirm: {
            text: "Proceed",
            closeModal: false, // Keep the modal open until validation
          },
        },
      }).then((remarks) => {
        if (remarks === null) {
          // User clicked 'Cancel', simply close the modal and do nothing
          swal.close();
          return;
        }

        // If 'Proceed' clicked but no remarks provided, show an error
        if (!remarks) {
          swal({
            title: "Remarks Required!",
            text: "Please enter a reason for the non-compliance before proceeding.",
            icon: "error",
          });
          return;
        }

        // Process with the entered remarks
        console.log('Processing with remarks:', remarks);
        formData1.append("Remarks", remarks);
        handleSave(formData1);

        // Close the modal manually after processing
        swal.close();
      }).catch((error) => {
        console.log('Process canceled or error:', error);
      });
    };


    showRemarkPrompt(); // Initial call to show the remark prompt
  };


  const handleInputChange = (parentIdx, index, e) => {
    const data = [ ...qualityData ];
    const { name, value, label ,setName} = e.currentTarget;
    if (index == "SampleName") {
      const newState = [...FinalResult];
      if (newState[parentIdx]) {
        newState[parentIdx]['Sample'] = e.currentTarget.value;
      } else {
        newState[parentIdx] = { Sample: e.currentTarget.value, Value: '' };
      }
      setFinalResult(newState);
    } else {

      const cloneObj=cloneDeep(data[parentIdx])
      cloneObj.Standard[index][name] = value;
      data[parentIdx] = cloneObj
    if(Enable){

       data[parentIdx].Standard[index]["SetName"] = setName;
    }
      if (name == "Result") {
        data[parentIdx].Standard[index]["ResultLabel"] = label;
      }
      setQualityData(data)


      // Ensure proper comparison, trimming whitespaces and handling case sensitivity
      // const allOK = data[parentIdx].Standard.every(item => item.Result.trim().toUpperCase() === 'OK');
      const allOK = data.every(sample => 
        sample.Standard.every(item => item.Result.trim().toUpperCase() === 'OK')
      );
      
      const hasNG = data[parentIdx].Standard.some(item => item.Result.trim().toUpperCase() === 'NG');

      console.log(data, "current target value", allOK, hasNG, 'test');
      if (allOK) {
        setFinalResult(prev => {
          const newState = [...prev];
          if (newState[parentIdx]) {
            newState[parentIdx]['Value'] = "OK";
          } else {
            newState[parentIdx] = { Sample: "", Value: 'OK' };
          }
          return newState;
        });
        return "OK";
      } else if (hasNG) {
        setFinalResult(prev => {
          const newState = [...prev];
          if (newState[parentIdx]) {
            newState[parentIdx]['Value'] = "NG";
          } else {
            newState[parentIdx] = { Sample: "", Value: 'NG' };
          }
          return newState;
        });
        return "NG";
      } else {
        setQualityData([...qualityData]); // Only update qualityData if no other condition is met
        return null;
      }
    }


  };
  const handleProcessWarnNG = (formData1) => {
    const showRemarkPrompt = () => {
      swal({
        title: "Are you sure?",
        text: "You want to submit NG Result for this inspection.",
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          confirm: {
            text: "Proceed",
            closeModal: false, // Keep the modal open until we validate the action
          },
        },
      }).then((proceed) => {
        // 'proceed' will be true only if the "Proceed" button is clicked
        if (proceed) {
          // Trigger the handleSave function only if the user confirms
          handleSave(formData1);

          // After processing, close the modal manually
          swal.close();
        }
      }).catch((error) => {
        console.log('Process canceled or error:', error);

        // Reset the button text to "Proceed" if any error occurs
        document.querySelector('.swal-button--confirm').innerText = "Proceed";
      });
    };


    showRemarkPrompt(); // Initial call to show the remark prompt
  };


  const handleOnSubmit = () => {

    const data = [...qualityData];
    console.log(data,"vskkdjhvsdib")
    const obj = {
      ApprovalReq: config.ApprovalReq, ApprovedBy: config.ApprovalRoles.map(x => { return { Role: x, Approved: false } }),
      Item: item.ItemName, ItemNumber: item.ItemNumber, Operation: item.Operation, Instrument: inputData.Instrument, InspectionType: ChecksheetType, DateTime: inputData.DateTime ? inputData.DateTime : new Date(), Checksheet: [], customFields: [...inputData.CustomFields, ...constantFields.map(x => { return { FieldName: x.FieldName, Value: x.Value } })], QtyToInspect: NumberOfSample,
      OkParts: (FinalResult.filter(one => one && one.Value === 'OK')).length,
      QtyInspected: FinalResult.length,
      sampleRef: FinalResult.map((sample, index) => {
        if (config.SampleSerial == "Manual") {
          return { Sample: sample.Sample, Value: sample.Value }
        } else {
          return { Sample: 'Sample' + (config.SampleSerialUnique == "Yes" ? (sampleStartIndex + index + 1) : "1"), Value: sample.Value }
        }
      }),
    }

    const constantColumn = selectedTemplate.Columns.filter(x => !x.DataType.startsWith('UserInput'))
    const userInput = columns.filter(x => x.DataType.startsWith('UserInput'))
    data[0].Standard.forEach((parameter, idx) => {
      const report = { Data: [] };
      constantColumn.forEach((constant) => report[constant.DbFieldName] = parameter[constant.DbFieldName])
      report["StandardType"] = parameter.StandardType
      data.forEach(item => {
        const matchingItem = item.Standard.filter((items, index) => idx === index);
        const dataObj = { Result: matchingItem[0].Result, ResultLabel: matchingItem[0].ResultLabel,SetName: matchingItem[0].SetName || "-" }
        userInput.forEach((input) => dataObj[input.DbFieldName] = matchingItem[0][input.DbFieldName])
        report.Data.push(dataObj);
      });
      obj.Checksheet.push(report);
    });
    console.log(obj,"souh")
    const error = validateCustomFields(obj);
    if (error) {
      //setErrors(error)
      const keys = Object.keys(error);
      const error1 = "Required fields cannot be left blank: " + keys.join(', ');
      swal('ERROR', error1, { dangerMode: true })
      return
    }

    const err = validateCheckSheetComplete(obj)
    if (err) {
      const userInputFields = columns.filter(x => x.DataType.startsWith('UserInputDecision'));
      swal('ERROR', "Check Points cannot be left blank. Please input for: " + userInputFields.map(x => x.FieldName).join(', '), { dangerMode: true })
      return
    }
    obj.Files = files;
    const formData1 = new FormData();
    formData1.append('Data', JSON.stringify(obj));

    Array.from(files).forEach(file => {
      formData1.append('files', file);
    });

    if (addMoreCount < NumberOfSample && config.ContinousDataEntry == "disable") {
      handleProcess(formData1)
    } else {
      if (config.NGResultWarning == "enable" && obj.sampleRef.some(x => x.Value == "NG")) {
        handleProcessWarnNG(formData1)
      } else {
        handleSave(formData1)
      }
    }
  }

  const handleSave = (formData1) => {
    console.log(formData1,"fiuhsdf")
    // return
    axios.post(api.api + 'checkSheetDataEntry', formData1, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((result) => {
        if (config.ContinousDataEntry == "enable") {
          // setQualityData([]);
          setInputData(prevInputData => ({
            ...prevInputData,
            // DateTime: new Date(),
            Instrument: [],
          }));

          initializedData();
          initializedInputFocus();
          //setFinalResult([])
          toast.success(`Data saved. Enter the next entry.`, {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              background: 'green', // Set your desired background color
              color: 'white',     // Set your desired text color
            },
          });
          //  swal("Data saved. Enter the next entry.");
        } else {
          swal("Data Saved Successfully");
          setQualityData([]);
          history.goBack();
        }
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          toast.success(`${err.response.data.message}`, {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              background: 'red', // Set your desired background color
              color: 'white',     // Set your desired text color
            },
          });
        }

        console.log(err);
      });
  }

  const [addMoreCount, setAddMoreCount] = useState(1); // State to keep track of the number of times addMore has been called

  const addMore = (setName) => {



    const data = cloneDeep(qualityData);
    const finalResult = cloneDeep(FinalResult);
    const obj = cloneDeep(data[data.length - 1]);
    finalResult.push({ Sample: '', Value: config.DefaultSelection })
    obj.Standard.forEach((one) => {
      delete one.ObservedValue;
      one.Result = config.DefaultSelection;
      delete one.Remarks;
    });
    setFinalResult(finalResult);
    setQualityData([...data, getNewCheckSheetObj(setName)]);
    setAddMoreCount(addMoreCount + 1); // Increment the count after successfully adding
  };
  const removeRow = () => {
    let data = [...qualityData];
    const results = [...FinalResult]
    results.splice(results.length - 1, 1)
    data.splice(data.length - 1, 1)
    setFinalResult(results);
    setAddMoreCount(prev => prev - 1)
    setQualityData(data);
  }
  const handelfinalResult = (data, parentIdx) => {
    console.log(data, "cdsjbchsdc");
    const OK = data.filter((one) => one.Result === "OK");
    const NG = data.filter((one) => one.Result === "NG");
    console.log(data.length, OK.length, "geurburb");
    if (data.length === OK.length) {
      return "OK";
    }
    if (NG.length > 0) {
      return "NG";
    }
  };

  const handleOnChangeDateTime = (type, value) => {
    let newDateTime;
    if (type === 'date') {
      // Update date part, keep time part
      const currentMoment = moment(inputData.DateTime);
      newDateTime = moment(value + "T" + currentMoment.format('HH:mm')).toDate();
    } else if (type === 'time') {
      // Update time part, keep date part
      const currentMoment = moment(inputData.DateTime);
      newDateTime = moment(currentMoment.format('YYYY-MM-DD') + "T" + value).toDate();
    }
    // handleOnChange("DateTime",newDateTime)
    setInputData({ ...inputData, DateTime: newDateTime });
  };


  const getDataTypeElement = (parentIdx, currentIdx, field, data, sheetLen) => {

    const dimensionTypes = ["Dimension+Tolerance", "Dimension-Tolerance", "StandardDimension"];
    if ((data.StandardType == "Description") && dimensionTypes.includes(field.DataType)) {
      return <></>
    }
    switch (field.DataType) {
      case 'UserInputDecision':
        if (data.StandardType == "Dimension") {
          const plusCol = selectedTemplate.Columns.find(x => x.DataType == "Dimension+Tolerance");
          const minusCol = selectedTemplate.Columns.find(x => x.DataType == "Dimension-Tolerance");
          const standardNum = selectedTemplate.Columns.find(x => x.DataType == "StandardDimension");
          return (
            <div >
                  { console.log("test-data-field", field,data) }

              <input
                onBlur={() => {
                  let observedValue = field.DbFieldName && parseFloat(data[field.DbFieldName]);
                  let plusValue = plusCol.DbFieldName && parseFloat(data[plusCol.DbFieldName]) ;
                  let minusValue = minusCol.DbFieldName && parseFloat(data[minusCol.DbFieldName]);
                  let standardValue = standardNum && standardNum.DbFieldName && parseFloat(data[standardNum.DbFieldName]);

                  const plus = standardValue + plusValue;
                  const minus = standardValue - minusValue;

                  // Clone qualityData to avoid mutating the state directly
                  const data1 = [...qualityData];

                  // Perform the check and update the result
                  if (!data1[parentIdx].Standard[currentIdx][field.DbFieldName]) {
                    data1[parentIdx].Standard[currentIdx]["Result"] = "NG";
                    data1[parentIdx].Standard[currentIdx]["ResultLabel"] = "NG";
                  }

                  else if (data1[parentIdx].Standard[currentIdx][field.DbFieldName] == "-") {
                    data1[parentIdx].Standard[currentIdx]["Result"] = "NA";
                    data1[parentIdx].Standard[currentIdx]["ResultLabel"] = "NA";
                  }

                  else if (minus <= observedValue && observedValue <= plus) {
                    data1[parentIdx].Standard[currentIdx]["Result"] = "OK";
                    data1[parentIdx].Standard[currentIdx]["ResultLabel"] = "OK";
                  }

                  // Update qualityData after processing
                  setQualityData(data1);

                  // Now call handleInputChange to ensure it runs in sync
                  handleInputChange(parentIdx, currentIdx, { currentTarget: { name: field.DbFieldName, value: data[field.DbFieldName] ,setName:data['SetName']} });
                }}
                pattern="^-?[0-9]*\.?[0-9]*$"
                type="text"
                className="form-control form-control-sm p-0 text-center"
                id={field.DbFieldName}
                name={field.DbFieldName}
                placeholder={field.placeholder || ''}
                ref={(el) => (inputRefs.current[`${parentIdx}-${currentIdx}`] = el)}  // Store ref for each input
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    const isLastField = currentIdx === sheetLen - 1;

                    if (isLastField && config.SampleSerial == "Manual") {
                      e.key === 'Enter' && handleFocusNext(`${parentIdx + 1}` + `Parent`)
                    }
                    else if (isLastField) {
                      // Move focus to the first input of the next section (e.g., `1-0`)
                      const nextSectionKey = `${parentIdx + 1}-0`;

                      handleFocusNext(nextSectionKey);  // Focus on the first input of the next section
                    } else {
                      const nextFieldKey = `${parentIdx}-${currentIdx + 1}`;
                      handleFocusNext(nextFieldKey);
                    }
                  }
                }}
                onChange={(e) => handleInputChange(parentIdx, currentIdx, {currentTarget: {
                  name: e.target.name,
                  value: e.target.value,
                  setName: data['SetName']
                }})}
                value={data[field.DbFieldName] || ""}
              />


            </div>
          );
        }
        else if (data.StandardType == "Description") {
          return (
            <div className='text-center d-flex '>
              {config.ResultConfigure && config.ResultConfigure.map((x, index) => {
                return <label
                  style={{ fontSize: 20, fontWeight: 'bold' }}
                  key={index}
                  className={`${index > 0 ? 'ml-3' : ''} ${focusedInput === `${parentIdx}-${currentIdx}` ? 'label-focused shadow' : ''}`} // Highlight label when focused
                >
                  <input
                    style={{ width: 22, height: 22 }}
                    className={`mt-1 ${focusedInput === `${parentIdx}-${currentIdx}` ? 'radio-focused' : ''}`} // Highlight radio button

                    type="radio"
                    name={field.DbFieldName + parentIdx + currentIdx}
                    value="OK"
                    checked={data.Result === x.TreatAs}
                    ref={(el) => (inputRefs.current[`${parentIdx}-${currentIdx}`] = el)} // Store ref for each input
                    onFocus={() => setFocusedInput(`${parentIdx}-${currentIdx}`)} // Set focused input
                    onBlur={() => setFocusedInput(null)} // Remove highlight on blur
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const isLastField = currentIdx === sheetLen - 1;

                        if (isLastField && config.SampleSerial == 'Manual') {
                          handleFocusNext(`${parentIdx + 1}` + `Parent`);
                        } else if (isLastField) {
                          const nextSectionKey = `${parentIdx + 1}-0`;
                          handleFocusNext(nextSectionKey); // Focus on the first input of the next section
                        } else {
                          const nextFieldKey = `${parentIdx}-${currentIdx + 1}`;
                          handleFocusNext(nextFieldKey);
                        }
                      }
                    }}
                    onChange={(e) =>
                      handleInputChange(parentIdx, currentIdx, {
                        currentTarget: {
                          name: "Result",
                          value: x.TreatAs,
                          label: x.Result,
                          setName: x.setName
                        },
                      }
                      )}
                  />
                  &nbsp;{x.Result}
                </label>
              })}

            </div>
          );
        }
        else { return 'NA' }
      case 'UserInputNumber':
        return (
          <div >
            <input
              type="number"
              className="form-control form-control-sm p-0 text-center"
              id={field.DbFieldName}
              name={field.DbFieldName}
              placeholder={field.placeholder || ''}
              onChange={(e) => handleInputChange(parentIdx, currentIdx, e)}
              value={data[field.DbFieldName] || ""}
              ref={(el) => (inputRefs.current[`${parentIdx}-${currentIdx}`] = el)}  // Store ref for each input
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const isLastField = currentIdx === sheetLen - 1;

                  if (isLastField && config.SampleSerial == "Manual") {
                    e.key === 'Enter' && handleFocusNext(`${parentIdx + 1}` + `Parent`)
                  }
                  else if (isLastField) {
                    // Move focus to the first input of the next section (e.g., `1-0`)
                    const nextSectionKey = `${parentIdx + 1}-0`;

                    handleFocusNext(nextSectionKey);  // Focus on the first input of the next section
                  } else {
                    const nextFieldKey = `${parentIdx}-${currentIdx + 1}`;
                    handleFocusNext(nextFieldKey);
                  }
                }
              }}
            // onKeyDown={(e) => {
            //   if (e.key === 'Enter') {
            //     const nextFieldKey = `${parentIdx}-${currentIdx + 1}`;
            //     handleFocusNext(nextFieldKey);  // Focus on the next input field
            //   }
            // }}
            />
          </div>
        );
      case 'UserInputString':
        return (
          <div >
            <input
              type="text"
              className="form-control form-control-sm p-0"
              id={field.DbFieldName}
              name={field.DbFieldName}
              value={data[field.DbFieldName] || ""}
              placeholder={field.placeholder || ''}
              ref={(el) => (inputRefs.current[`${parentIdx}-${currentIdx}`] = el)}  // Store ref for each input
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const isLastField = currentIdx === sheetLen - 1;

                  if (isLastField && config.SampleSerial == "Manual") {
                    e.key === 'Enter' && handleFocusNext(`${parentIdx + 1}` + `Parent`)
                  }
                  else if (isLastField) {
                    // Move focus to the first input of the next section (e.g., `1-0`)
                    const nextSectionKey = `${parentIdx + 1}-0`;

                    handleFocusNext(nextSectionKey);  // Focus on the first input of the next section
                  } else {
                    const nextFieldKey = `${parentIdx}-${currentIdx + 1}`;
                    handleFocusNext(nextFieldKey);
                  }
                }
              }}
              onChange={(e) => handleInputChange(parentIdx, currentIdx, e)}
            />
          </div>
        );
      case 'ConstantString':
        return (
          <div>
            <p className='custom-paragraph'>{data[field.DbFieldName] || ""}</p>

          </div>
        );
      case 'StandardDimension':
        return (
          <div >
            <input
              disabled
              type="number"
              value={data[field.DbFieldName] || ""}
              className="form-control form-control-sm p-0 text-center"
              id={field.DbFieldName}
              name={field.DbFieldName}
              placeholder={field.placeholder || ''}
            // onChange={handleOnChange}
            />
          </div>
        );
      case 'Dimension+Tolerance':
        return (
          <div >
            <input
              disabled
              type="number"
              value={data[field.DbFieldName] || ""}
              className="form-control form-control-sm p-0 text-center"
              id={field.DbFieldName}
              name={field.DbFieldName}
              placeholder={field.placeholder || '+ Tolerance'}
            // onChange={handleOnChange}
            />
          </div>
        );
      case 'Dimension-Tolerance':
        return (
          <div >
            <input
              disabled
              type="number"
              value={data[field.DbFieldName] || ""}
              className="form-control form-control-sm p-0 text-center"
              id={field.DbFieldName}
              name={field.DbFieldName}
              placeholder={field.placeholder || '- Tolerance'}
            // onChange={handleOnChange}
            />
          </div>
        );
      default:
        return <></>;
    }
  }


  const getDeafultSelectAll = (parentIdx, field) => {
    if (field.DataType == "UserInputDecision") {
      return (
        <div className='text-center d-flex'>
          {config.ResultConfigure && config.ResultConfigure.map((x, index) => {
            return x.IsEnableAll && <label
              style={{ fontWeight: 'bold', fontSize: 15 }}
              className={index > 0 ? "ml-3" : ""}>
              <input
                // style={{ width: 22, height: 22 }}
                className='mt-1'
                type="radio"
                name={"All" + parentIdx}
                value="OK"
                checked={qualityData[parentIdx].Standard.length == qualityData[parentIdx].Standard.filter(res => res.Result == x.TreatAs).length}
                onChange={(e) => {
                  const data = [...qualityData]
                  data[parentIdx].Standard.forEach((check) => {
                    check.Result = x.TreatAs;
                  })
                  if (data[parentIdx].Standard.filter(x => x.Result == "OK").length == data[parentIdx].Standard.length) {
                    setFinalResult(prev => {
                      const newState = [...prev];
                      if (newState[parentIdx]) {
                        newState[parentIdx]['Value'] = "OK";
                      } else {
                        newState[parentIdx] = { Sample: "", Value: 'OK' };
                      }
                      return newState;
                    });
                  } else {
                    setFinalResult(prev => {
                      const newState = [...prev];
                      if (newState[parentIdx]) {
                        newState[parentIdx]['Value'] = "NG";
                      } else {
                        newState[parentIdx] = { Sample: "", Value: 'NG' };
                      }
                      return newState;
                    });
                  }
                  setQualityData(data)
                }}
              />
              &nbsp;All {x.Result}
            </label>
          })}

        </div>
      );
      return <></>
    }
    return <></>
  }

  const getListNames = () => {
    axios.get(api.api + 'ListMaster')
      .then((result) => {
        // consol(result.data)
        setLoader(false)
        setList(result.data);
      })
      .catch((err) => {
        swal(`${err}`)
        setLoader(false)
      })
  }


  const getListValues = (item1) => {
    const itemMaster = item.Inspection.find(x => x.InspectionName === ChecksheetType);
    const field = itemMaster.CustomFields.find(x => x.FieldName == item1.FieldName)

    if (!field) return [];

    const listItem = List.find(listItem => listItem.ListName == field.ListName);

    if (!listItem) return [];

    return { options: listItem.contents.map(content => { return { label: content, value: content } }), isMulti: field.EnableMultiSelect };
  };


  const getCarryValue = (field, defaultValue) => {
    const fields = [...inputData.CustomFields];
    const value = fields.find(x => field && x && x.FieldName == field.FieldName);
    if (value && value.Value) {
      return value.Value
    }
    return defaultValue
  }

  const YourComponent = () => {
    // Array to track printed SetNames, move it outside map to persist across iterations
    let printedSetNames = [];
  
    const renderSetName = (sample) => {
      // If SetName hasn't been printed, print it and add it to the array
      if (!printedSetNames.includes(sample.SetName)) {
        printedSetNames.push(sample.SetName);
        return <h4 style={{ fontSize: 15, marginTop: 15 }}>{sample.SetName}</h4>;
      }
      // Otherwise, return null to avoid duplicate printing
      return null;
    };
  
    return (
      <>
        {qualityData.length > 0 ? (
          <>
            {qualityData.map((sample, parentIdx) => (
              <React.Fragment key={parentIdx}>
                {/* Call renderSetName to conditionally print SetName */}
                {renderSetName(sample)}
  
                <h4 style={{ fontSize: 15, marginTop: 15 }}>
                  Sample Serial :
                  {config && config.SampleSerial === "Manual" ? (
                    <input
                      ref={(el) => (inputRefs.current[`${parentIdx}Parent`] = el)}
                      onKeyDown={(e) => e.key === 'Enter' && handleFocusNext(`${parentIdx}${0}`)}
                      onChange={(e) => handleInputChange(parentIdx, 'SampleName', e)}
                      placeholder='enter manual sample..'
                      style={{ width: '30%' }}
                      type='text'
                      className='form-control form-control-sm'
                    />
                  ) : (
                    '#' + (config.SampleSerialUnique === "Yes"
                      ? sampleStartIndex + parentIdx + 1
                      : parentIdx + 1)
                  )}
                </h4>
  
                {/* Table rendering */}
                <table style={{ tableLayout: 'auto', display: 'table' }} className="small table-sm table-bordered table-responsive">
                  <thead>
                    <tr className='text-center'>
                      {columns.map((x, idx) => <th key={idx}>{x.FieldName}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {sample.Standard.map((one, index) => {
                      const color = config.ResultConfigure.find(x => x.TreatAs === one.Result);
                      return (
                        <tr className='text-center' style={{ backgroundColor: color ? color.Color : "", padding: 0 }} key={index}>
                          {columns.map((x, idx) => (
                            <td key={idx}>{getDataTypeElement(parentIdx, index, x, one, sample.Standard.length, columns)}</td>
                          ))}
                        </tr>
                      );
                    })}
                    <tr className='text-center' style={{ backgroundColor: "lightgray", padding: 0 }} key="All">
                      {columns.map((x, idx) => (
                        <td key={idx}>{getDeafultSelectAll(parentIdx, x)}</td>
                      ))}
                    </tr>
                  </tbody>
                </table>
  
                <div className='text-center'>
                  {sample.Standard.length > 0 && (
                    <div className='p-2 text-white fw-bold' style={{ backgroundColor: `${handelfinalResult(sample.Standard) === 'OK' ? 'green' : 'red'}` }}>
                      Result : {handelfinalResult(sample.Standard, parentIdx)}
                    </div>
                  )}
                </div>
              </React.Fragment>
            ))}
  
            {/* Buttons for adding/removing rows */}
            <div className='d-flex float-end'>
              <div>
                {qualityData.length > 1 && !Enable &&(
                  <span className="mt-2 mr-4 float-right" style={{ cursor: 'pointer' }} onClick={removeRow}>
                    <FontAwesomeIcon size='2x' icon={faMinusCircle} />
                  </span>
                )}
                {config.ContinousDataEntry === "disable" && !Enable && (
                  <span className="mt-2 mr-4 float-right" style={{ cursor: 'pointer' }} onClick={addMore}>
                    <FontAwesomeIcon size='2x' icon={faPlusCircle} />
                  </span>
                )}
              </div>
              <div className='mx-1 d-flex align-items-center fw-bolder mt-1'>
                <button className='btn-sm btn-primary' onClick={() => handleOnSubmit()}>Submit</button>
              </div>
            </div>
          </>
        ) : (
          <p className="mt-5 small text-center">No Data</p>
        )}
      </>
    );
  };
  
  return (
    < >
      {loader ? <Loading labelShow={true} label={"Loading..."} /> : ''}

      {/* <div className='text-center' >
        <p >{ChecksheetType} Report</p>
      </div> */}
      {/* <ToastContainer /> */}

      <div className="row">
        <div className='col-sm-3 mt-4'>
          <h5>Item Number :{obj.ItemNumber}</h5>
        </div>
        {config.CustomFields && config.CustomFields.length > 0 && config.CustomFields.filter(x => !x.Constant).map((item, indext) => item.DataType !== 'list' ?
          item.DataType == "high_speed_string" ?
            <HighSpeedDataType

              indext={indext}
              config={config}
              handleFocusNext={handleFocusNext}
              inputRefs={inputRefs}
              field={item}
              value={getCarryValue(item, '')}
              getString={(string) => handleOnChange(item.FieldName, string, indext)}
            />
            :
            item.DataType == "float" ?
              <div className='col-sm-3 mt-4'>
                <div className="form-group "><label className='small d-flex mb-0'>{item.FieldName}{item.Compulsory && <p style={{ height: 5 }} className='text-danger '>*</p>}</label >
                  <input className='form-control form-control-sm' name={item.FieldName} type={"number"} value={getCarryValue(item, '')}
                    ref={(el) => (inputRefs.current[`0-${indext}-float`] = el)}  // Store ref
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const isLastField = indext === config.CustomFields.length - 1;

                        // Find the next non-select input field
                        let nextIndex = indext + 1;
                        while (nextIndex < config.CustomFields.length && config.CustomFields[nextIndex].DataType === 'list') {
                          nextIndex++; // Skip the select fields
                        }

                        if (isLastField && config.SampleSerial === "Manual") {
                          handleFocusNext(`${0}Parent`);  // Move to the parent if last field
                        } else if (isLastField) {
                          // Move focus to the first input of the next section (e.g., `1-0`)
                          handleFocusNext(`0-0`);
                        } else if (nextIndex < config.CustomFields.length) {
                          // Focus on the next input field (skipping select)
                          handleFocusNext(`0-${nextIndex}-${config.CustomFields[nextIndex].DataType === 'float' ? 'float' : 'text'}`);
                        }
                      }
                    }}

                    step="0.01" onChange={(values) => { handleOnChange(item.FieldName, values.currentTarget.value, indext) }} placeholder={'Enter ' + item.FieldName} />
                  {errors && errors[item.FieldName] ? <p className='small text-danger'>{errors[item.FieldName]}</p> : <></>}
                </div>
              </div> :
              <div className='col-sm-3 mt-4 '>
                <div className="form-group d-flex-"><label className='small d-flex mb-0'>{item.FieldName}{item.Compulsory && <p style={{ height: 5 }} className='text-danger '>*</p>}</label >
                  <input className='form-control form-control-sm' name={item.FieldName} value={getCarryValue(item, '')}
                    ref={(el) => (inputRefs.current[`0-${indext}-text`] = el)}  // Store ref
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const isLastField = indext === config.CustomFields.length - 1;

                        // Find the next non-select input field
                        let nextIndex = indext + 1;
                        while (nextIndex < config.CustomFields.length && config.CustomFields[nextIndex].DataType === 'list') {
                          nextIndex++; // Skip the select fields
                        }

                        if (isLastField && config.SampleSerial === "Manual") {
                          handleFocusNext(`${0}Parent`);  // Move to the parent if last field
                        } else if (isLastField) {
                          // Move focus to the first input of the next section (e.g., `1-0`)
                          handleFocusNext(`0-0`);
                        } else if (nextIndex < config.CustomFields.length) {
                          // Focus on the next input field (skipping select)
                          handleFocusNext(`0-${nextIndex}-${config.CustomFields[nextIndex].DataType === 'float' ? 'float' : 'text'}`);
                        }
                      }
                    }}

                    type={item.DataType === 'string' ? 'text' : item.DataType} onChange={(values) => { handleOnChange(item.FieldName, values.currentTarget.value, indext) }} placeholder={'Enter ' + item.FieldName} />
                  {errors && errors[item.FieldName] ? <p className='small text-danger'>{errors[item.FieldName]}</p> : <></>}
                </div>
              </div> :
          <div className='col-sm-3 mt-4'>
            <label className='small d-flex mb-0'>{item.FieldName}{item.Compulsory && <p style={{ height: 5 }} className='text-danger '>*</p>}</label >
            <Select

              mode={getListValues(item).isMulti ? "multiple" : ''}
              className='form-control form-control-sm m-0 '
              placeholder={"Select " + item.FieldName}
              value={getCarryValue(item, [])}
              //value={inputData[item.FieldName]}
              onChange={(values) => {
                handleOnChange(item.FieldName, values, indext)
              }}
              style={{ width: '100%' }}
              options={getListValues(item).options}
            />
            {errors && errors[item.FieldName] ? <p className='small text-danger'>{errors[item.FieldName]}</p> : <></>}
          </div>
        )}
        {constantFields && constantFields.length > 0 && constantFields.map((item, indext) =>
          item.DisplayForDataEntry && <div className='col-sm-3 mt-4 text-center'>
            <div style={{ height: 18 }} className='row text-left ml-1'>
              <label className='small'>{item.FieldName}</label >
            </div>
            <div className='row'>
              <div className="form-group ">
                <input value={item.Value || ""} className='form-control form-control-sm' name={item.FieldName} type={"text"} disabled />
              </div>

            </div>

          </div>
        )}

      </div>
      <div className='row'>
        {config.DateTime == "Manual" && <div className='col-sm-3 mt-2'>
          Date &nbsp;:&nbsp; <input value={inputData.DateTime ? moment(inputData.DateTime).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChangeDateTime('date', e.currentTarget.value)} type='date' />
        </div>}
        {config.DateTime == "Manual" && <div className='col-sm-3 mt-2'>
          Time &nbsp;:&nbsp; <input value={inputData.DateTime ? moment(inputData.DateTime).format('HH:mm') : moment().format('HH:mm')} className='form-control form-control-sm' onChange={(e) => handleOnChangeDateTime('time', e.currentTarget.value)} type='time' />
        </div>}
        {/* <div className='col-sm-3 mt-2'>
          <label>Instrument Type : </label>
          <Select
            // maxTagCount='responsive'
            //mode="multiple"
            placeholder="Select Type"
            value={inputData.InstrumentType || []}
            onChange={(values) => {
              const data={...inputData}
              data.InstrumentType=values
              setInputData(data)
            }}
            style={{ width: '100%' }}
            options={types}
          />
        </div> */}
        {config.InstrumentReq == "enable" && <div className='col-sm-4 mt-2'>
          <label>Instrument : </label>
          <Select
            // maxTagCount='responsive'
            mode="multiple"
            placeholder="Select Instrument"
            value={inputData.Instrument.map(x => { return { label: x.Instrument, value: x.Instrument } }) || []}
            onChange={(values, all) => {
              const data = { ...inputData }
              data.Instrument = all.map(x => { return { Instrument: x.label, InstrumentType: x.type } })
              setInputData(data)
            }}
            style={{ width: '100%' }}
            options={instruments}
          // options={instruments.filter((x)=>x.type==inputData.InstrumentType)}
          />
        </div>}
      </div>
      <div className='relative' style={{ marginBottom: '200px' }}>
      {YourComponent()}
      </div>



      <div className="Inspection-floatingcard  d-flex align-items-center p-2" style={{ position: 'fixed', width: '100%', bottom: 0, height: '9vh' }}>
        <div style={{ width: "100%" }} className='d-flex justify-content-between  '>

          <div style={{ width: "45%" }} className='d-flex '>
            {console.log(FinalResult,"sdousoi", (FinalResult.filter(one => one.Value === 'OK')).length)}
            <div className='mx-3 fs-5 d-flex align-items-center fw-bolder'>
              Items Inspected: {FinalResult.length}/{NumberOfSample && Enable ?NumberOfSample*NumberOfSet:NumberOfSample} <br />
              Done / Total as per Std

            </div >
            <div className='mx-3 fs-5 d-flex align-items-center fw-bolder' >
              Result : {FinalResult.length > 0 && (FinalResult.filter(one => one.Value === 'OK')).length}/{FinalResult.length}  <br />
              OK / Total Inspected

            </div>
          </div>

          <div style={{ width: "35%" }} className='  '>
            <div className='desktop-only mt-3' >
              <div className='d-flex'>
                {/* <div className='mx-1 d-flex align-items-center fw-bolder'>
                    <button className='btn-sm btn-primary' > Save</button>

                  </div > */}

                <div className='mx-1 d-flex align-items-center fw-bolder' >
                  <button className='btn-sm btn-warning' onClick={() => history.goBack()}> Exit</button>

                  {/* <div className='mt-1 d-flex align-items-center fw-bolder' >
                    <button className='btn-sm btn-primary' onClick={() => handleOnSubmit()}> Submit</button>


                  </div> */}
                </div>
              </div>


            </div>
            <div className='mobile-only'>
              <div className='mt-1 d-flex align-items-center fw-bolder'>
                <button className='btn-sm btn-primary' > Save</button>

              </div >
              <div className='mt-1 d-flex align-items-center fw-bolder' >
                <button className='btn-sm btn-primary' onClick={() => handleOnSubmit()}> Submit</button>


              </div>
              <div className='mt-1 d-flex align-items-center fw-bolder' >
                <button className='btn-sm btn-warning' onClick={() => history.goBack()}> Exit</button>


              </div>
            </div>


          </div>
        </div>

      </div>

      <Modal
        title="Selected Image"
        visible={isModalVisible}
        onCancel={handleModalClose}
        footer={[
          <Button
            key="close"
            onClick={
              handleModalClose
            }
          >
            Close
          </Button>,
        ]}
      >
        {ModalImage && (
          <img
            src={ModalImage}
            alt="Selected"
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
          />
        )}
      </Modal>
    </>
  );
}
export default MainReport;